import styled from '@emotion/styled';

import * as React from 'react';

import { easeTransform } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';

import { observer } from 'src/utils/mobx-react';



const setChevronPosition = (position: 'up' | 'right' | 'down' | 'left'): string => {

    if (position === 'right') {

        return 'rotate(0)';

    }



    if (position === 'down') {

        return 'rotate(90deg)';

    }



    if (position === 'up') {

        return 'rotate(-90deg)';

    }



    return 'rotate(180deg)';

};



interface SvgElementPropsType {

    position: 'up' | 'right' | 'down' | 'left';

}



const SvgElement = styled('svg', { label: 'SvgElement' })<SvgElementPropsType>`

    height: auto;

    transform: ${({ position } ): string => setChevronPosition(position)};

    transition: ${easeTransform};

`;



interface ChevronPropsType {

    className?: string;

    onClick?: (e: React.SyntheticEvent) => void;

    position: 'up' | 'right' | 'down' | 'left';

    dataTest?: string;

}



export const ChevronIcon = observer('ChevronIcon', ({ className, onClick, position, dataTest }: ChevronPropsType): JSX.Element => {

    return (

        <SvgElement

            className={className}

            fill='#141922'

            height='16'

            onClick={onClick}

            position={position}

            viewBox='0 0 16 16'

            width='16'

            xmlns='http://www.w3.org/2000/svg'

            data-test={dataTest}

        >

            <path d='M5.556 14.667 4 13.11 9.111 8 4 2.889l1.556-1.556L12.222 8l-6.666 6.667Z' fill='fill'/>

        </SvgElement>

    );

});

